import { ResultsPaginationType } from '@data/types';
import useQuestionnaireStore from '@store/questionnaire';
import React from 'react';
import { hash, scrollToDiv } from 'utilities/helper';

import PaginationItem from './PaginationItem';

interface Props extends ResultsPaginationType {}

const ResultsPagination: React.FC<Props> = ({
  backgroundColour = '',
  pillarIndex,
}) => {
  const { pillarsLengthStore } = useQuestionnaireStore();

  return (
    <ol className="my-8 border-t-4 2xl:border-t-0 2xl:border-l-4 border-blue-light/[.20] hidden 2xl:flex 2xl:flex-col 2xl:gap-8 text-xs text-white/[0.20] ml-4 2xl:ml-0 2xl:pb-4 2xl:pl-2 leading-none 2xl:w-[55px] 2xl:mt-0 2xl:absolute 2xl:top-18 2xl:-left-20">
      {Array.from({ length: pillarsLengthStore }, (_, index) => {
        if (index === 0) return null;

        return (
          <PaginationItem
            index={index}
            backgroundColour={backgroundColour}
            onClick={() => scrollToDiv(`pillar-${index}`)}
            key={hash([index])}
            progress={index <= pillarIndex}
          />
        );
      })}
    </ol>
  );
};

export default ResultsPagination;
